// extracted by mini-css-extract-plugin
module.exports = {"header":"MicroCard_header__CrdFp","wrapper":"MicroCard_wrapper__3vNnh","micro":"MicroCard_micro__ARXqd"};